export default [
  {
    path: '/restricted-keyword/add',
    name: 'update-restricted-keyword',
    component: () => import('@/views/restricted-keyword/action.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Update Restricted Keyword',
      parent: 'restrictedKeywordList',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Restricted Keyword', url: '/restricted-keyword/add' },
        { title: 'Update Restricted Keyword', active: true }
      ]
    }
  }
]
